<script>
    export default {
        name: "BaseTextarea",
        props: {
            name: String,
            value: {
                type: String,
            },
            placeholder: {
                type: String,
                default: "",
            },
            errorText: String,
            minHeight: {
                type: Number,
                default: 180,
            },
        },
        computed: {
            classNames() {
                return [
                    this.errorText ? "base-textarea--error" : "",
                    String(this.value).length > 0 ? "base-textarea--active" : "",
                ];
            },
        },
        methods: {
            keyupElement({ key }) {
                if (key !== "Enter") {
                    this.error = "";
                    this.$emit("error", this.name);
                }
            },
        },
    };
</script>

<template>
    <label class="base-textarea">
        <textarea
            :value="value"
            class="base-textarea__field base-input__field"
            :class="classNames"
            :style="{ minHeight: `${minHeight}px` }"
            :name="name"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            @keyup="keyupElement"
        ></textarea>
        <span v-if="errorText" class="base-textarea__error">
            {{ errorText }}
        </span>
    </label>
</template>

<style lang="scss">
    .base-textarea {
        display: block;
    }

    .base-textarea__field {
        display: block;
        width: 100%;
        margin-top: 12px;
        border: var(--input-border-width) solid var(--input-border-color);
        resize: vertical;
        outline: none;
        &:hover:not(.base-textarea--error),
        &:focus:not(.base-textarea--error) {
            border-color: var(--input-border-color--hover);
        }
        &.base-textarea--error {
            border-color: var(--input-border-color--error);
        }
    }

    .base-textarea--active {
        &:not(.base-textarea--error) {
            border-color: var(--input-border-color--active);
        }
        &:hover:not(.base-textarea--error),
        &:focus:not(.base-textarea--error) {
            border-color: var(--input-border-color--active);
        }
    }

    .base-textarea__error {
        display: block;
        margin-top: 4px;
        padding-left: 12px;
        font-size: 12px;
        line-height: 16px;
        color: var(--input-text-color--error);
        text-align: left;
    }
</style>
